/**
 * 用户管理翻译 - 英文
 * Users - English
 */
import { UsersTranslations } from './zh';

export const usersEn: UsersTranslations = {
  // Page title
  title: 'User Management',
  subtitle: 'Manage system users and permissions',
  
  // Validation messages
  requiredFields: 'Please fill in all required fields',
  passwordTooShort: 'Password must be at least 6 characters',
  
  // Create user
  createLocal: 'Create Local User',
  fillUserInfo: 'Fill in user information',
  createSuccess: 'User created successfully',
  createFailed: 'Failed to create user',
  
  // Entra ID sync
  ldapSync: 'Entra ID Sync',
  syncing: 'Syncing...',
  confirmSync: 'Are you sure you want to sync Entra ID user data?',
  syncSuccess: 'Entra ID sync completed',
  syncFailed: 'Entra ID sync failed',
  lastSync: 'Last Sync',
  never: 'Never',
  created: 'Created',
  updated: 'Updated',
  skipped: 'Skipped',
  conflicts: 'Conflicts',
  conflictsDesc: 'These users exist in both LDAP and local but have mismatched information',
  errorDetails: 'Error Details',
  andMore: 'and',
  moreErrors: 'more errors',
  
  // Search and filter
  searchPlaceholder: 'Search users...',
  allStatus: 'All Status',
  filtered: 'filtered',
  
  // Status
  statusActive: 'Active',
  statusInactive: 'Inactive',
  statusSuspended: 'Suspended',
  
  // Table
  employee: 'Employee',
  source: 'Source',
  actions: 'Actions',
  local: 'Local',
  totalUsers: 'Total',
  
  // Hints
  noUsers: 'No users',
  noUsersDesc: 'Click button above to create or sync users from LDAP',
  
  // Form fields
  basicInfo: 'Basic Information',
  accountInfo: 'Account Information',
  personalInfo: 'Personal Information',
  username: 'Username',
  usernameHint: 'For login, letters, numbers, and underscores only',
  usernamePlaceholder: 'Enter username',
  password: 'Password',
  passwordHint: 'At least 6 characters',
  passwordPlaceholder: 'Enter password',
  email: 'Email',
  emailPlaceholder: 'Enter email',
  displayName: 'Display Name',
  displayNamePlaceholder: 'Enter display name',
  phone: 'Phone',
  phonePlaceholder: 'Enter phone number',
  employeeId: 'Employee ID',
  employeeIdPlaceholder: 'Enter employee ID',
  department: 'Department',
  selectDepartment: 'Select department',
  deptTitle: 'Department Title',
  titlePlaceholder: 'e.g.: Technical Lead',
  manager: 'Manager',
  selectManager: 'Select Manager (Optional)',
  position: 'Position',
  selectPosition: 'Select position',
  selectDepartmentFirst: 'Please select department first',
  noManager: 'No manager',
  status: 'Status',
  hiredAt: 'Hire Date',

  // User detail page (v2.4: read-only SSO binding section)
  detail: {
    sso: {
      sectionTitle: 'SSO Binding',
      externalId: 'External ID',
      externalSource: 'Identity Source',
      lastLoginAt: 'Last SSO Sign-in',
      source: {
        entra: 'Microsoft Entra',
        ldap: 'LDAP',
        ldapPending: 'LDAP / Pending SSO Upgrade',
        none: 'Not bound',
      },
      neverLoggedIn: 'Never signed in via SSO',
      copyId: 'Copy ID',
      copiedToast: 'Copied to clipboard',
    },
  },
};
